import React, { useEffect, useState } from 'react';
import { Box, Spinner } from '@chakra-ui/react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

function DoctorLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [doctorSession, setDoctorSession] = useState(null);

  useEffect(() => {
    const checkAuth = () => {
      const sessionData = localStorage.getItem('doctorSession');
      
      // If not logged in and not on login page, redirect to login
      if (!sessionData && location.pathname !== '/doctor/login') {
        navigate('/doctor/login', { replace: true });
        setLoading(false);
        return;
      }

      // If logged in and on login page, redirect to dashboard
      if (sessionData && location.pathname === '/doctor/login') {
        navigate('/doctor/dashboard', { replace: true });
        setLoading(false);
        return;
      }

      // If logged in, validate session
      if (sessionData) {
        try {
          const parsedSession = JSON.parse(sessionData);
          
          // Check if session is expired (24 hours)
          const loginTime = new Date(parsedSession.loginTime);
          const now = new Date();
          const hoursDiff = (now - loginTime) / (1000 * 60 * 60);
          
          if (hoursDiff > 24) {
            // Session expired
            localStorage.removeItem('doctorSession');
            navigate('/doctor/login', { replace: true });
            setLoading(false);
            return;
          }
          
          setDoctorSession(parsedSession);
        } catch (error) {
          // Invalid session data
          localStorage.removeItem('doctorSession');
          navigate('/doctor/login', { replace: true });
          setLoading(false);
          return;
        }
      }

      setLoading(false);
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (loading) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.50">
        <Spinner size="xl" color="blue.500" />
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg="gray.50">
      <Outlet context={{ doctorSession }} />
    </Box>
  );
}

export default DoctorLayout;
